import { abbreviateNumber } from '../../../../../../../../../frontend/libs/shared-vanilla/src/lib/abbreviated-number-with-suffix';

// All logic for this filter has been moved into the new @angular/shared codebase
export default function AbbreviatedNumberWithSuffixFilter() {
  return (val: number): string => {
    return abbreviateNumber(val);
  };
}
